// Positions are viewport-relative, so the mouse follows the real responsive logo.
export const CYCLE_SECONDS = 56;
const mix = (a, b, t) => a + (b - a) * Math.max(0, Math.min(1, t));
const ease = (t) => (1 - Math.cos(Math.PI * Math.max(0, Math.min(1, t)))) / 2;

export function mousePose(seconds, { width, height, logo, size }) {
  const t = seconds % CYCLE_SECONDS;
  const spriteHeight = size * 280 / 240;
  const edge = logo.right - 3;
  const hidden = edge - size;
  const leftEdge = logo.left + 3;
  const peek = leftEdge - size * 0.68;
  const navY = Math.max(0, logo.bottom - spriteHeight + 12);
  const floorY = Math.max(navY, height - spriteHeight - 28);
  const middle = width * 0.58;
  const pose = { visible: true, x: hidden, y: navY, facing: 1, kind: 'peek', clip: edge, clipRight: 0 };
  const peeking = { ...pose, clip: 0, clipRight: width - leftEdge };
  if (t < 1.2) return { ...pose, visible: false };
  if (t < 6) return { ...pose, kind: 'run', facing: -1, x: mix(width + size, hidden, (t - 1.2) / 4.8) };
  if (t < 7) return { ...pose, visible: false };
  if (t < 8) return { ...peeking, x: mix(leftEdge, peek, ease(t - 7)) };
  if (t < 14) return { ...peeking, x: peek, phase: 'peek-hold' };
  if (t < 15) return { ...peeking, x: mix(peek, leftEdge, ease(t - 14)) };
  if (t < 17) return { ...pose, visible: false };
  if (t < 22) return { ...pose, kind: 'run', x: mix(hidden, width + size, (t - 17) / 5) };
  if (t < 27) return { ...pose, visible: false };
  if (t < 32) return { ...pose, kind: 'run', facing: -1, clip: 0, y: floorY, x: mix(width + size, middle, (t - 27) / 5) };
  if (t < 35) return { ...pose, clip: 0, y: floorY, x: middle };
  if (t < 40) return { ...pose, kind: 'run', facing: -1, clip: 0, y: floorY, x: mix(middle, -size, (t - 35) / 5) };
  return { ...pose, visible: false };
}

export function isMouseRoute(pathname) {
  return !/(checkout|booking|basket|payment|confirmation|members-area|account|login|\/explore(?:\/|$)|\/tickets(?:\/|$)|day-tickets)/i.test(pathname);
}

// Keep long fullscreen crossings at a readable pace instead of covering an
// ever-larger distance in the same five seconds. Pauses keep their normal timing.
export function mousePlaybackRate({width,size,logo}) {
  const crossingDistance=width+size-(logo.right-3-size);
  return Math.min(1, 150*4.8/Math.max(1,crossingDistance));
}
